export class GeneratorAbortionError extends Error {}
